import MutationTypes from '@/store/constants/mutations';

export default {
  methods: {
    hideMenu() {
      this.$store.commit(MutationTypes.SET_SHOW_MENU, false);
    },
  },
};
